import { useCallback, useState } from 'react';

export const useModalState = (
  initialState?: boolean,
): {
  modalOpened: boolean;
  openModal: VoidFunction;
  closeModal: VoidFunction;
} => {
  const [modalOpened, setModalOpened] = useState<boolean>(initialState || false);

  const openModal = useCallback(() => setModalOpened(true), [setModalOpened]);
  const closeModal = useCallback(() => setModalOpened(false), [setModalOpened]);

  return {
    modalOpened,
    openModal,
    closeModal,
  };
};
